import React, { useState, useEffect } from 'react'
import { useAuth } from '../context/AuthContext'
import { organizationApi } from '../api/services'
import toast, { Toaster } from 'react-hot-toast'

// ── Icons  ──────────────────────────────────────
const Icons = {
  ChevronRight: props => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      strokeWidth={1.5}
      stroke='currentColor'
      {...props}
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M8.25 4.5l7.5 7.5-7.5 7.5'
      />
    </svg>
  ),
  Building: props => (
    <svg
      width='19'
      height='20'
      viewBox='0 0 19 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M16.4062 6.5625H11.8125V1.96875C11.8125 1.4466 11.6051 0.945846 11.2359 0.576634C10.8667 0.207421 10.3659 0 9.84375 0H1.96875C1.4466 0 0.945846 0.207421 0.576634 0.576634C0.207421 0.945846 0 1.4466 0 1.96875V19.0312C0 19.2053 0.0691404 19.3722 0.192211 19.4953C0.315282 19.6184 0.482202 19.6875 0.65625 19.6875H4.92188C5.0089 19.6875 5.09236 19.6529 5.15389 19.5914C5.21543 19.5299 5.25 19.4464 5.25 19.3594V16.4247C5.25 16.0716 5.52152 15.7685 5.87467 15.7508C5.9634 15.7465 6.05207 15.7603 6.13532 15.7913C6.21857 15.8223 6.29465 15.8699 6.35896 15.9312C6.42327 15.9925 6.47448 16.0662 6.50946 16.1479C6.54445 16.2295 6.56249 16.3174 6.5625 16.4062V19.3594C6.5625 19.4464 6.59707 19.5299 6.65861 19.5914C6.72014 19.6529 6.8036 19.6875 6.89062 19.6875H17.7188C17.8928 19.6875 18.0597 19.6184 18.1828 19.4953C18.3059 19.3722 18.375 19.2053 18.375 19.0312V8.53125C18.375 8.0091 18.1676 7.50835 17.7984 7.13913C17.4292 6.76992 16.9284 6.5625 16.4062 6.5625Z'
        fill='#313131'
      />
      <path
        d='M15.0938 15.75C14.964 15.75 14.8371 15.7885 14.7292 15.8606C14.6212 15.9327 14.5371 16.0352 14.4875 16.1551C14.4378 16.275 14.4248 16.407 14.4501 16.5343C14.4754 16.6616 14.5379 16.7785 14.6297 16.8703C14.7215 16.9621 14.8384 17.0246 14.9657 17.0499C15.093 17.0752 15.225 17.0622 15.3449 17.0125C15.4648 16.9629 15.5673 16.8788 15.6394 16.7708C15.7115 16.6629 15.75 16.536 15.75 16.4062C15.75 16.2322 15.6809 16.0653 15.5578 15.9422C15.4347 15.8191 15.2678 15.75 15.0938 15.75Z'
        fill='#313131'
      />
      <path
        d='M12.4688 9.1875C12.339 9.1875 12.2121 9.22599 12.1042 9.2981C11.9962 9.37021 11.9121 9.4727 11.8625 9.59261C11.8128 9.71253 11.7998 9.84448 11.8251 9.97178C11.8504 10.0991 11.9129 10.216 12.0047 10.3078C12.0965 10.3996 12.2134 10.4621 12.3407 10.4874C12.468 10.5127 12.6 10.4997 12.7199 10.45C12.8398 10.4004 12.9423 10.3163 13.0144 10.2083C13.0865 10.1004 13.125 9.97354 13.125 9.84375C13.125 9.6697 13.0559 9.50278 12.9328 9.37971C12.8097 9.25664 12.6428 9.1875 12.4688 9.1875Z'
        fill='#313131'
      />
    </svg>
  ),
  Plus: props => (
    <svg
      width='25'
      height='25'
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.5 4.6875C12.9315 4.6875 13.2812 5.03728 13.2812 5.46875V11.7188H19.5312C19.9627 11.7188 20.3125 12.0685 20.3125 12.5C20.3125 12.9315 19.9627 13.2812 19.5312 13.2812H13.2812V19.5312C13.2812 19.9627 12.9315 20.3125 12.5 20.3125C12.0685 20.3125 11.7188 19.9627 11.7188 19.5312V13.2812H5.46875C5.03728 13.2812 4.6875 12.9315 4.6875 12.5C4.6875 12.0685 5.03728 11.7188 5.46875 11.7188H11.7188V5.46875C11.7188 5.03728 12.0685 4.6875 12.5 4.6875Z'
        fill='#313131'
      />
    </svg>
  ),
  Pencil: props => (
    <svg
      width='17'
      height='17'
      viewBox='0 0 17 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.1331 2.31548C12.3612 2.31534 12.58 2.40589 12.7413 2.56719L13.6827 3.50859C13.844 3.66989 13.9345 3.88869 13.9344 4.11679C13.9343 4.3449 13.8434 4.56358 13.6819 4.72468L3.0257 15.3548C2.94585 15.4344 2.85111 15.4976 2.74687 15.5406L1.1875 16.1848C0.866523 16.3173 0.497295 16.2437 0.25173 15.9982C0.00616552 15.7526 -0.0674648 15.3834 0.065122 15.0624L0.709263 13.503C0.75232 13.3988 0.815475 13.304 0.895124 13.2242L11.5252 2.56793C11.6863 2.40644 11.905 2.31562 12.1331 2.31548Z'
        fill='#313131'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.1409 0.114524C14.3234 0.0389162 14.5191 0 14.7166 0C14.9142 0 15.1098 0.0389162 15.2923 0.114524C15.4748 0.190126 15.6407 0.300933 15.7804 0.440624L15.8099 0.470147C16.0917 0.752226 16.2501 1.13468 16.2501 1.53345C16.2501 1.93222 16.0917 2.31468 15.8099 2.59675L15.3491 3.05753C15.0135 3.39313 14.4694 3.39313 14.1338 3.05753L13.1924 2.11612C13.0311 1.95491 12.9406 1.73625 12.9406 1.50827C12.9407 1.28028 13.0313 1.06166 13.1926 0.900523L13.6529 0.440659C13.7928 0.3008 13.9585 0.190081 14.1409 0.114524Z'
        fill='#313131'
      />
    </svg>
  ),
  Trash: props => (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M16.875 3.75H13.125V2.8125C13.125 2.3981 12.9604 2.00067 12.6674 1.70765C12.3743 1.41462 11.9769 1.25 11.5625 1.25H8.4375C8.0231 1.25 7.62567 1.41462 7.33265 1.70765C7.03962 2.00067 6.875 2.3981 6.875 2.8125V3.75H3.125C2.95924 3.75 2.80027 3.81585 2.68306 3.93306C2.56585 4.05027 2.5 4.20924 2.5 4.375C2.5 4.54076 2.56585 4.69973 2.68306 4.81694C2.80027 4.93415 2.95924 5 3.125 5H3.78906L4.53125 16.9109C4.58672 17.9598 5.39062 18.75 6.40625 18.75H13.5938C14.6145 18.75 15.4023 17.9773 15.4688 16.9141L16.2109 5H16.875C17.0408 5 17.1997 4.93415 17.3169 4.81694C17.4342 4.69973 17.5 4.54076 17.5 4.375C17.5 4.20924 17.4342 4.05027 17.3169 3.93306C17.1997 3.81585 17.0408 3.75 16.875 3.75Z'
        fill='#FF696D'
      />
    </svg>
  )
}

// ── Recursive Node  ────────────────────────
const OrgNode = ({ org, level, onAddChild, onDelete, onEdit, canEdit }) => {
  const [isExpanded, setIsExpanded] = useState(true)
  const hasChildren = org.children && org.children.length > 0

  return (
    <div className='border border-gray-100 bg-white first:rounded-t-lg last:rounded-b-lg mb-2 shadow-sm rounded-lg overflow-hidden'>
      <div
        className='flex items-center justify-between py-4 px-4 hover:bg-gray-50 transition-colors'
        style={{ paddingLeft: `${level * 24 + 16}px` }}
      >
        <div className='flex items-center gap-3'>
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className={`p-1 text-gray-400 hover:text-gray-600 transition-transform ${
              hasChildren ? '' : 'invisible'
            } ${isExpanded ? 'rotate-90' : ''}`}
          >
            <Icons.ChevronRight className='w-4 h-4' />
          </button>

          <div className='text-gray-700'>
            <Icons.Building className='w-5 h-5' />
          </div>

          <span className='font-medium text-gray-800 text-sm'>{org.name}</span>
        </div>

        {canEdit && (
          <div className='flex items-center gap-4 text-gray-400 pr-2'>
            <button
              onClick={() => onAddChild(org.id)}
              className='hover:text-blue-600 transition-colors'
              title='Add Sub-Division'
            >
              <Icons.Plus className='w-5 h-5' />
            </button>
            <button
              onClick={() => onEdit(org)}
              className='hover:text-blue-600 transition-colors'
              title='Edit Name'
            >
              <Icons.Pencil className='w-5 h-5' />
            </button>
            <button
              onClick={() => onDelete(org.id)}
              className='hover:text-red-600 transition-colors'
              title='Delete Group'
            >
              <Icons.Trash className='w-5 h-5' />
            </button>
          </div>
        )}
      </div>

      {isExpanded && hasChildren && (
        <div className='bg-gray-50/50 border-t border-gray-100'>
          {org.children.map(child => (
            <OrgNode
              key={child.id}
              org={child}
              level={level + 1}
              onAddChild={onAddChild}
              onDelete={onDelete}
              onEdit={onEdit}
              canEdit={canEdit}
            />
          ))}
        </div>
      )}
    </div>
  )
}

// ── Main Page Component ────────────────────────────────────────────────────────
const OrganizationHierarchy = () => {
  const { activeTenant, hasRole, user } = useAuth()
  // FIX: extract numeric id whether activeTenant is an object {id,name} or a raw number
  const resolvedTenantId =
    (typeof activeTenant === 'object' ? activeTenant?.id : activeTenant) ??
    user?.tenant_id
  const canEdit = hasRole('admin', 'tenant_admin', 'super_admin')

  const [organizations, setOrganizations] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [editingOrg, setEditingOrg] = useState(null) // null = adding, obj = editing
  const [parentIdToAdd, setParentIdToAdd] = useState(null)
  const [orgName, setOrgName] = useState('')
  const [isSaving, setIsSaving] = useState(false)

  // ── Fetch from API ───────────────────────────────────────────────────────────
  const fetchOrganizations = async () => {
    try {
      setIsLoading(true)
      // FIX: pass correct { tenantId } shape so the query param is set
      const response = await organizationApi.getAll({
        tenantId: resolvedTenantId
      })
      setOrganizations(response.data?.data || response.data || [])
    } catch {
      toast.error('Failed to load groups')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchOrganizations()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resolvedTenantId])

  // ── Save (Create or Edit) ────────────────────────────────────────────────────
  const handleSave = async e => {
    e.preventDefault()
    if (!orgName.trim()) return
    setIsSaving(true)

    try {
      if (editingOrg) {
        // ── EDIT mode ────────────────────────────────────────────────────────
        // FIX: pass resolvedTenantId so super_admin requests include tenant_id query param
        await organizationApi.update(
          editingOrg.id,
          { name: orgName },
          resolvedTenantId
        )
        toast.success('Group updated')
      } else {
        // ── ADD mode ─────────────────────────────────────────────────────────
        // FIX: pass resolvedTenantId as second arg so super_admin requests work
        await organizationApi.create(
          {
            name: orgName,
            parent_id: parentIdToAdd
          },
          resolvedTenantId
        )
        toast.success('Group created')
      }
      await fetchOrganizations()
      closeModal()
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to save group')
    } finally {
      setIsSaving(false)
    }
  }

  // ── Delete ───────────────────────────────────────────────────────────────────
  const handleDelete = async id => {
    if (!window.confirm('Delete this group and all its sub-divisions?')) return
    try {
      // FIX: pass resolvedTenantId so super_admin requests include tenant_id query param
      await organizationApi.delete(id, resolvedTenantId)
      toast.success('Group deleted')
      await fetchOrganizations()
    } catch {
      toast.error('Failed to delete group')
    }
  }

  // ── Modal helpers ────────────────────────────────────────────────────────────
  const openAddModal = (parentId = null) => {
    setEditingOrg(null)
    setParentIdToAdd(parentId)
    setOrgName('')
    setIsModalOpen(true)
  }

  const openEditModal = org => {
    setEditingOrg(org)
    setOrgName(org.name)
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setEditingOrg(null)
    setParentIdToAdd(null)
    setOrgName('')
  }

  // ── Render ───────────────────────────────────────────────────────────────────
  return (
    <div className='bg-gray-50 min-h-screen p-8 font-sans'>
      <Toaster position='top-right' />

      {/* Header */}
      <div className='flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4'>
        <div>
          <h1 className='text-2xl font-bold text-gray-800'>Group Hierarchy</h1>
          <p className='text-sm text-gray-500 mt-1'>
            Manage your groups, subdivisions, and divisions
          </p>
        </div>
        {canEdit && (
          <button
            onClick={() => openAddModal(null)}
            className='flex items-center gap-2 bg-blue-800 hover:bg-blue-900 text-white px-6 py-2.5 rounded-lg font-medium shadow-sm transition-colors'
          >
            <Icons.Plus className='w-5 h-5' />
            Add Group
          </button>
        )}
      </div>

      {/* Main Content */}
      <div className='bg-white rounded-xl shadow-sm border border-gray-200 p-6 min-h-[400px]'>
        <h2 className='text-lg font-bold text-gray-800 mb-1'>
          Group Structure
        </h2>
        <p className='text-xs text-gray-500 mb-6'>
          Click on nodes to expand/collapse. Use the action buttons to manage
          groups and subdivisions.
        </p>

        {isLoading ? (
          <div className='flex justify-center py-12 text-gray-500'>
            Loading structure...
          </div>
        ) : (
          <div className='space-y-2'>
            {organizations.length > 0 ? (
              organizations.map(org => (
                <OrgNode
                  key={org.id}
                  org={org}
                  level={0}
                  onAddChild={openAddModal}
                  onDelete={handleDelete}
                  onEdit={openEditModal}
                  canEdit={canEdit}
                />
              ))
            ) : (
              <div className='text-center py-12 border-2 border-dashed border-gray-100 rounded-lg'>
                <div className='inline-flex items-center justify-center w-12 h-12 rounded-full bg-gray-50 mb-3'>
                  <Icons.Building className='w-6 h-6 text-gray-300' />
                </div>
                <p className='text-gray-500 text-sm'>No groups found.</p>
                {canEdit && (
                  <button
                    onClick={() => openAddModal(null)}
                    className='text-blue-600 font-medium text-sm mt-2 hover:underline'
                  >
                    Create your first group
                  </button>
                )}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Modal (identical layout to your original) */}
      {isModalOpen && (
        <div className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4'>
          <div className='bg-white rounded-xl shadow-xl w-full max-w-sm overflow-hidden transform transition-all'>
            <div className='px-6 py-4 border-b border-gray-100 flex justify-between items-center bg-gray-50'>
              <h3 className='text-lg font-bold text-gray-800'>
                {editingOrg ? 'Edit Group' : 'Add Group'}
              </h3>
              <button
                onClick={closeModal}
                className='text-gray-400 hover:text-gray-600'
              >
                <svg
                  className='w-5 h-5'
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M6 18L18 6M6 6l12 12'
                  />
                </svg>
              </button>
            </div>
            <form onSubmit={handleSave} className='p-6'>
              <div className='mb-6'>
                <label className='block text-sm font-medium text-gray-700 mb-2'>
                  Group Name
                </label>
                <input
                  type='text'
                  value={orgName}
                  onChange={e => setOrgName(e.target.value)}
                  required
                  placeholder='e.g. Manufacturing Division'
                  autoFocus
                  className='w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all'
                />
              </div>
              <div className='flex gap-3'>
                <button
                  type='button'
                  onClick={closeModal}
                  className='flex-1 px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50'
                >
                  Cancel
                </button>
                <button
                  type='submit'
                  disabled={isSaving}
                  className='flex-1 px-4 py-2 bg-blue-800 text-white font-medium rounded-lg hover:bg-blue-900 disabled:opacity-60 disabled:cursor-not-allowed'
                >
                  {isSaving
                    ? 'Saving...'
                    : editingOrg
                    ? 'Save Changes'
                    : 'Create'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}

export default OrganizationHierarchy
